module.exports = __webpack_public_path__ + "static/media/poppins-v5-latin-ext-700.1271e83e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/poppins-v5-latin-ext-700.woff
// module id = ./src/common/fonts/poppins-v5-latin-ext-700.woff
// module chunks = 1